import moment from 'moment'

export const formatPrice = (number: number, maximumFractionDigits: number|null = 2) => {
    const options = maximumFractionDigits === null ? {} : {maximumFractionDigits};
    return Number(number).toLocaleString("sk-SK", options);
};

export const formatDate = (date: string) => {
    return moment(date).format('DD.MM.YYYY');
};

export const formatDateTime = (date: string) => {
    return moment(date).format('DD.MM.YYYY HH:mm:ss');
};

export const validateForm = (form: any) => {
    form.validate();
    return form.errors.length === 0;
};
